import './style.scss';
import ErrorDisplay from "../errorDisplay";
import MultiSelect from "react-select";
import MultiSelector from "../multiSelector";

let idx = 0;

const Selector = (props) => {
  const {
    name,
    id,
    label,
    value,
    optionLabelField,
    optionValueField,
    isOptionDisabled,
    changeAction,
    onKeyDown,
    showLabel,
    disabled,
    items,
    hide,
    multiple,
    errors,
    focusOnError
  } = props;

  const idValue = id || label || name;

  const hasError = Boolean(errors?.length);
  const errorId = 'error-' + idx++;

  const dropdownOptions = (items) ? Object.values(items) : [];

  return (
    <div className="selector">
      {multiple ? <MultiSelector
        id={id}
        label={label}
        name={name}
        showLabel={showLabel}
        values={value}
        hide={hide}
        items={items}
        changeAction={changeAction}
        optionLabelField={optionLabelField}
        optionValueField={optionValueField}
      /> : <><label htmlFor={idValue}><span className={(showLabel && !hide) ? '' : 'sr-hide'}>{label || name}</span></label>
        <select
      className={(hide) ? 'sr-hide' : (value === '') ? 'default' : ''}
      name={name || label || id}
      id={idValue}
      value={value}
      disabled={disabled}
      multiple={multiple}
      onChange={(e) => {
        e.preventDefault();
        if (typeof changeAction === 'function') {
          changeAction(e.target.value, e.target.selectedIndex);
        }
      }}
      onKeyDown={onKeyDown || null}
      >

        {
          dropdownOptions.map((item, idx) => {
            let label = (optionLabelField ? item[optionLabelField] : item.label);
            let value = (optionValueField ? item[optionValueField] : item.value);
            let key = (item.key ? item.key : idx);

            return (
              <option value={value} key={key} disabled={isOptionDisabled && isOptionDisabled(item)}>{label}</option>
            );
          })
        }

      </select></>}
      { hasError && <ErrorDisplay shouldFocus={focusOnError} errors={errors} id={errorId}/> }
    </div>
  )
};

export default Selector;
